import React from 'react';
import { mockData } from '../mock';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const ServicesPage = () => {
  const IconComponent = ({ iconName }) => {
    const Icon = LucideIcons[iconName] || LucideIcons.Circle;
    return <Icon className="w-8 h-8" />;
  };

  const serviceLinks = [
    'kitchen-renovations',
    'bathroom-installations', 
    'extensions-loft-conversions',
    'property-refurbishment',
    'painting-decorating',
    'general-maintenance',
    'landscaping',
    'cleaning-services'
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Construction Services Ipswich - Kitchen, Bathroom, Extensions"
        description="Professional construction services in Ipswich, Suffolk. Kitchen renovations, bathroom installations, house extensions, painting & decorating. FREE quotes. 5-star rated builders."
        keywords="kitchen renovation Ipswich, bathroom installation Suffolk, house extensions Essex, painting decorating Ipswich, loft conversion Suffolk, property refurbishment, builders services, construction services near me"
        canonical="/services"
      />
      <section className="pt-56 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">Our Services</h1>
            <p className="text-xl text-gray-600">
              Comprehensive construction and renovation solutions for properties across Suffolk, Essex, and London.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockData.services.map((service, index) => (
              <Link key={service.id} to={`/services/${serviceLinks[index]}`}>
                <Card className="hover:shadow-xl transition-all duration-300 group h-full cursor-pointer">
                  <CardHeader>
                    <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mb-4 group-hover:bg-black transition-colors duration-300">
                      <IconComponent iconName={service.icon} />
                    </div>
                    <CardTitle className="text-2xl group-hover:text-orange-600 transition-colors">{service.title}</CardTitle>
                    <CardDescription className="text-gray-600 text-base">{service.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center text-orange-600 font-semibold group-hover:translate-x-2 transition-transform">
                      Learn More
                      <LucideIcons.ArrowRight className="w-5 h-5 ml-2" />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <Link to="/contact">
            <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors">
              Request a Quote
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;